export const longCachedQueryOptions = {
  cacheTime: Infinity,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
};
